import ReportPullup from '@/components/pull-up/report-pullup/report-pullup';
import { ClassProgressReportModel } from '@/models/groups/class';
import { formatTime } from '@/utils/date';
import { getGradeRange } from '@/utils/utils';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import CPContentActivityCard from '../cp-content-activity-card/cp-content-activity-card';
import CPContentCard from '../cp-content-card/cp-content-card';
import JsonCSV from 'vue-json-csv';
import { blob, csv } from 'd3';

Vue.component('downloadCsv', JsonCSV);

@Component({
    name: 'cp-student-details',
    components: {
        'cp-content-card': CPContentCard,
        'assessment-report': ReportPullup,
        'cp-content-activity-card': CPContentActivityCard,

    },
})

export default class CpStudentDetails extends Vue {

    // -----------------------------------------------------------------
    // Properties
    @Prop()
    private membersList!: ClassProgressReportModel;

    @Prop()
    private activeMember!: ClassProgressReportModel;

    @Prop()
    private studentDetails!: ClassProgressReportModel;

    @Prop()
    private showStudentDetails!: boolean;

    @Prop()
    private isPdfContent!: boolean;

    private isReportByDate: boolean = false;

    @Prop()
    private isDetailLoading!: boolean;

    private isShowReport: boolean = false;

    @Prop()
    private classData!: any;

    @Prop()
    private dateRange!: any;

    @Prop()
    private analyticsDataReport!: any;

    @Prop()
    private overallReportHeaders!: any;

    @Prop()
    private overviewReport!: any;

    @Prop()
    private activeReport!: any;

    @Prop()
    private pdfPropData!: any;

    private collectionData: any;

    private CSVreport: any = [];

    @Prop()
    private showOverflowContent!: boolean;

    // --------------------------------------------------------------------
    // Actions
    private onSelectContent(collection: any) {
        this.collectionData = collection;
        this.isShowReport = true;
        collection.format = collection.format ? collection.format : 'assessment';
    }

    // -------------------------------------------------------------------
    // Methods
    private getGradeRange(value: number) {
        return getGradeRange(value);
    }

    private formatTime(value: number) {
        return formatTime(value);
    }

    private getReportData(overviewReport: any) {
        const keyValues = [
            'code',
            'description',
            'report_date',
            'score',
            'tries',
        ];

        keyValues.forEach((key: any) => {
            overviewReport[key] = '';
            overviewReport.forEach((value: any) => {
                if (key === 'report_date') {
                    overviewReport[key] += (moment(value[key]).format('DD MMM YYYY')) + '_';
                } else {
                    value[key] = value[key] ? value[key] : '-';
                    overviewReport[key] += (JSON.stringify(value[key])) + '_';
                }
            });
        });
        return overviewReport;
    }

    private GenerateCSVReport(member: any) {

        const header = [
            'collection time spent',
            'Student Name',
            'Class Name',
            'Teacher Name',
            'Report Date Range',
            '\n',
            'Competencies Mastered',
            'Competencies In progress',
            '\n',
            'Time Spent on Collections',
            'Time Spent on Assessments',
            'Total time spent',
            '\n',
            'Challenges Mastered',
            'Longest Mastery Streak (lessons in a row)',
            'Scored at least 90%',
            'Suggestions Taken',
            '\n',
            'Competencies Mastered (score ≥ 80%)',
            'Title',
            'Mastery Date',
            'Score',
            'Number of Tries',
            '\n',
            'Targets for Growth (51% - 79%)',
            'Title',
            'Date of Most Recent Attempt ',
            'Most Recent Score',
            'Number of Tries',
            '\n',
            'Diagnostics Gains',
            'Title',
            'Date of Most Recent Attempt ',
            'Most Recent Score',
            'Number of Tries',
            '\n',
            'Areas of Concern (< 51%)',
            'Title',
            'Date of Most Recent Attempt',
            'Most Recent Score',
            'Number of Tries',
            '\n',
            'Reinforced Gains',
            'Title',
            'Date of Most Recent Attempt ',
            'Most Recent Score',
            'Number of Tries',
            '\n',
            'Incomplete Competencies',
            'Title',
            'Date of Most Recent Attempt ',
            'Most Recent Score',
            'Number of Tries',
            '\n',
        ];

        const dateRange = this.dateRange;
        const masteredLength = (member.mastered.length > 1) ? member.mastered.length : '0';
        const diagnosticsMasteryLength = (member.diagnosticsMastery.length > 1)
            ? member.diagnosticsMastery.length : '0';

        const competenciesMastered = member.mastered.length + member.diagnosticsMastery.length;
        const inProgressLength = member.inprogress.length > 1 ? member.inprogress.length : '0';

        const streakCompetencies = this.analyticsDataReport.streakStatsData.streak_competencies ?
            this.analyticsDataReport.streakStatsData.streak_competencies : '0';

        const masteredStatsData = this.analyticsDataReport.masteredStatsData.comp_scored_more_than_90 ?
            this.analyticsDataReport.masteredStatsData.comp_scored_more_than_90 : '0';

        const suggestionStatsData = this.analyticsDataReport.suggestionStatsData.accepted_suggestions ?
            this.analyticsDataReport.suggestionStatsData.accepted_suggestions : '0';

        const masteredList = this.getReportData(this.overviewReport.masteredList);
        const growthList = this.getReportData(this.overviewReport.growthList);
        const concernList = this.getReportData(this.overviewReport.concernList);
        const diagnostic = this.getReportData(this.overviewReport.diagnostic);
        const reinforcedList = this.getReportData(this.overviewReport.reinforcedList);
        const assessmentInProgress = this.getReportData(this.overviewReport.assessmentInProgress);

        const bodyContainer = [
            this.formatTime(member.collectionTimespent),
            member.firstName + ' ' + member.lastName,
            this.classData.name,
            this.membersList.teacher.firstName + ' ' + this.membersList.teacher.lastName,
            moment(dateRange.startDate).format('DD MMM YYYY') + '  '
            + moment(dateRange.endDate).format('DD MMM YYYY'),
            (competenciesMastered > 1) ? competenciesMastered : '0',
            inProgressLength,
            this.formatTime(member.collectionTimespent),
            this.formatTime(member.assessmentTimespent),
            this.formatTime(member.totalTimespent),
            diagnosticsMasteryLength,
            streakCompetencies,
            masteredStatsData,
            suggestionStatsData,
            masteredList.code ? masteredList.code : '-',
            masteredList.description ? masteredList.description : '-',
            masteredList.report_date ? masteredList.report_date : '-',
            masteredList.score ? masteredList.score : '-',
            masteredList.tries ? masteredList.tries : '-',
            growthList.code ? growthList.code : '-',
            growthList.description ? growthList.description : '-',
            growthList.report_date ? growthList.report_date : '-',
            growthList.score ? growthList.score : '-',
            growthList.tries ? growthList.tries : '-',
            diagnostic.code ? diagnostic.code : '-',
            diagnostic.description ? diagnostic.description : '-',
            diagnostic.report_date ? diagnostic.report_date : '-',
            diagnostic.score ? diagnostic.score : '-',
            diagnostic.tries ? diagnostic.tries : '-',
            concernList.code ? concernList.code : '-',
            concernList.description ? concernList.description : '-',
            concernList.report_date ? concernList.report_date : '-',
            concernList.score ? concernList.score : '-',
            concernList.tries ? concernList.tries : '-',
            reinforcedList.code ? reinforcedList.code : '-',
            reinforcedList.description ? reinforcedList.description : '-',
            reinforcedList.report_date ? reinforcedList.report_date : '-',
            reinforcedList.score ? reinforcedList.score : '-',
            reinforcedList.tries ? reinforcedList.tries : '-',
            assessmentInProgress.code ? assessmentInProgress.code : '-',
            assessmentInProgress.description ? assessmentInProgress.description : '-',
            assessmentInProgress.report_date ? assessmentInProgress.report_date : '-',
            assessmentInProgress.score ? assessmentInProgress.score : '-',
            assessmentInProgress.tries ? assessmentInProgress.tries : '-',
        ];

        let index = 0;
        const csvData: any = [];

        header.forEach((title: any) => {
            if (bodyContainer[index]) {
                if (title !== '\n') {
                    const csvContent: any = [];
                    const arrayString = bodyContainer[index].toString();
                    arrayString.split('_').map((item: any) => {
                        csvContent.push(item);
                    });
                    csvData.push([title, ...csvContent]);
                    index++;
                } else {
                    csvData.push([title, '']);
                }
                csvData.push('\n');
            }
        });

        this.CSVreport = csvData;

        const CSVfileName = member.firstName + '-' + member.lastName + '-' + moment(dateRange.startDate).format('MMM-YYYY') + '.csv';
        const csvDownload = new Blob(this.CSVreport, { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(csvDownload);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', CSVfileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

    }

    private onGeneratePdf() {
        this.$emit('onGeneratePdf');
    }
}
